import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.TUggpX',
    defaultMessage: 'Social login',
  },
  connectAccount: {
    id: 'studio.40zOQn',
    defaultMessage: 'Connect {name} account',
  },
  disconnectAccount: {
    id: 'studio.HzbcJI',
    defaultMessage: 'Disconnect {name} account',
  },
  disconnectError: {
    id: 'studio.Y5XkIv',
    defaultMessage: 'There was a problem disconnecting {name}',
  },
  disconnectSuccess: {
    id: 'studio.1IRjYb',
    defaultMessage: 'Disconnected {name} successfully',
  },
  error: {
    id: 'studio.8OHgiT',
    defaultMessage: 'There was a problem loading your connected accounts. Please try again.',
  },
});
